// @flow
import { authenticatedFetch, unauthenticatedFetch } from '../../../api/request';

export default async function setNotificationSetting(
    key: string,
    enabled: boolean,
    token: string
) {
    if (token) {
        return await unauthenticatedFetch(`/public/v5/emailSettings`, {
            method: 'PUT',
            body: JSON.stringify({
                key,
                enabled,
                token
            })
        });
    }

    return await authenticatedFetch(`/v5/notifications/settings`, {
        method: 'PUT',
        body: JSON.stringify({
            key,
            enabled
        })
    });
}



// WEBPACK FOOTER //
// ./src/v5/notificationSettings/api/setNotificationSetting.js